import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutHero() {
  const bioRef = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="relative pt-36 pb-20 overflow-hidden bg-white">
      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Left: Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div
                className="absolute inset-0 rounded-2xl"
                style={{ background: 'linear-gradient(135deg, #B8860B, #8B0000)', filter: 'blur(20px)', opacity: 0.15 }}
              />
              <img
                src="https://static.readdy.ai/image/73df10f1d2f13e308059e9f42ef7d721/9ada0b3c38d1594cb9890affd165d5b2.png"
                alt="Benny Legacy - Professional Fitness Coach"
                className="relative rounded-2xl w-full object-cover object-top shadow-2xl"
                style={{ height: '600px', border: '3px solid #B8860B' }}
              />
            </div>
          </div>

          {/* Right: Bio */}
          <div ref={bioRef} className="order-1 lg:order-2 scroll-animate-slide-right">
            <div
              className="inline-block text-xs font-bold tracking-widest uppercase mb-4 px-4 py-2 rounded-full"
              style={{ background: 'rgba(184,134,11,0.12)', color: '#B8860B' }}
            >
              Meet Your Coach
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight" style={{ color: '#1a1a1a' }}>
              Benny <span style={{ background: 'linear-gradient(90deg, #B8860B, #d4a017)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Legacy</span>
            </h1>
            <div className="space-y-5 text-sm sm:text-base leading-relaxed" style={{ color: '#444444' }}>
              <p>
                <strong style={{ color: '#B8860B' }}>15+ years</strong> of transforming lives. From Ottawa to Toronto to clients around the world, Benny Legacy has built a reputation as one of Canada's most trusted fitness coaches.
              </p>
              <p>
                A certified personal trainer, nutrition specialist, and competitive bodybuilder, Benny doesn't just talk the talk — he walks the walk. He's been on stage, in the trenches, and through the grind. He knows what it takes to build a body worth being proud of.
              </p>
              <p>
                But this isn't just about abs and biceps. Benny's philosophy, <strong style={{ color: '#B8860B' }}>The Legacy Mindset</strong>, is about building discipline, consistency, and a life that reflects your highest potential. It's about becoming the best version of yourself.
              </p>
              <p>
                Whether you're training in person in Toronto or virtually from anywhere on the planet, Benny brings the same intensity, accountability, and results driven approach that's helped hundreds of people transform their bodies and their lives.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-10">
              {[
                { number: '15+', label: 'Years Experience' },
                { number: '500+', label: 'Lives Transformed' },
                { number: '100%', label: 'Commitment' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-3xl sm:text-4xl font-extrabold mb-1" style={{ background: 'linear-gradient(90deg, #B8860B, #d4a017)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                    {stat.number}
                  </div>
                  <div className="text-xs font-medium" style={{ color: '#888888' }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}